class Header {
  host: Element;

  constructor(host: Element) {
    this.host = host;
  }

  init() {
    const pageTitle = document.querySelector(".page-title");

    if (pageTitle) {
      const pageTitleText = pageTitle.textContent || "";
      const pageTitleWords = pageTitleText.split(" ");
      const pageTitleWordsWithSpans = pageTitleWords.map((word) => {
        const classNames = ["word"];
        if (["vita", "sua"].includes(word.toLowerCase())) {
          classNames.push("mark");
        }
        return `<span class="${classNames.join(" ")}">${word}</span>`;
      });
      pageTitle.innerHTML = pageTitleWordsWithSpans.join(" ");
    }
  }
}

(() => {
  const headerElement = document.querySelector(".vs-header");
  if (headerElement) {
    const header = new Header(headerElement);
    header.init();
  }
})();
